module.exports = __webpack_public_path__ + "static/media/TechStackIcon.3cba97de.svg";